// extracted by mini-css-extract-plugin
export default {"Search":"search__Search__Sm7I8","Input":"search__Input__Hu0OD","Icon":"search__Icon__A5n8S","Dark":"search__Dark__csASa"};